
  import "./AdiminD.css"
 function AdminDas(){
     return (
       <div className="admin">
         <h2>Admin Dasboard</h2>
       </div>
     );
 }
  export default AdminDas